import moment from 'moment';
import VanillaCalendar from 'vanilla-calendar-pro';

export function initCalendar() {
    const calendarEl = document.getElementById('calendar');
    const roomTypeEl = document.getElementById('room_type');
    const postIdEl = document.getElementById('post_id');

    if (!calendarEl || !roomTypeEl || !postIdEl) {
        return;
    }

    const currentLanguageCode = document.documentElement.lang.split('-')[0];
    let allDates = [];
    let allowedDates = [];

    function updateCalendar(start, end, room_type, post_id) {
        const data = {
            start_date: start,
            end_date: end,
            room_type: room_type,
            post_id: post_id,
        };
        fetch('/wp-json/api/availability', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        })
            .then(response => response.json())
            .then(data => {
                const available = data.data.available;
                allDates = available;
                const datesAvailable = data.data.dates_available;
                allowedDates = datesAvailable.filter(date => moment(date).format('YYYY-MM-DD'));
                const htmls = {};
                const popups = {};
                for (const data of available) {
                    for (const date of data['dates']) {
                        if (htmls[date]) {
                            const list = htmls[date];
                            list.push(data['room_type_name'] + ' ' + data['room_name']);
                            htmls[date] = list;
                        } else {
                            htmls[date] = [data['room_type_name'] + ' ' + data['room_name']];
                        }
                    }
                }

                for (const date in htmls) {
                    const uniqueHtml = htmls[date].filter((value, index, array) => {
                        return array.indexOf(value) === index;
                    });
                    popups[date] = {
                        modifier: '',
                        html: Object.values(uniqueHtml).join('<br>'),
                    };
                }

                calendar.popups = popups;
                calendar.settings.range.enabled = allowedDates;
                calendar.update();

            })
            .catch(error => console.error(error));
    }

    function formatDate(date) {
        return date.toLocaleDateString('lt-LT', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        });
    }

    function getDays(start, end) {
        const arr = [];
        for(const dt= new Date(start); dt <= new Date(end); dt.setDate(dt.getDate() + 1)){
            arr.push(formatDate(new Date(dt)));
        }
        return arr;
    }

    const start = new Date();
    let end = new Date(start);
    end.setMonth(end.getMonth() + 2);

    const room_type = roomTypeEl.value;
    const post_id = postIdEl.value;

    updateCalendar(start, end, room_type, post_id);
    const calendar = new VanillaCalendar('#calendar', {
        date: {
            min: formatDate(new Date()),
            max: formatDate(new Date(new Date().setFullYear(new Date().getFullYear() + 1))),
        },
        settings: {
            lang: currentLanguageCode,
            range: {
                disablePast: true,
                disableAllDays: true,
                enabled: [],
            },
            selection: {
                day: 'multiple-ranged',
            },
            visibility: {
                theme: 'light',
                weekNumbers: true,
                disabled: true,
            },
        },
        actions: {
            clickDay(event, self) {
                if (self.selectedDates.length === 1) {
                    let minSelect = 0;
                    if (allDates) {
                        for (const data of allDates) {
                            const details = data['dates_detailed'][self.selectedDates[0]];
                            if (details && details['los_min']) {
                                minSelect = details['los_min'] - 1;
                                if (minSelect < 1) minSelect = 0;
                            }
                        }
                    }

                    let nextDate = new Date(self.selectedDates[0]);
                    nextDate.setDate(nextDate.getDate() + minSelect);
                    nextDate = formatDate(nextDate);

                    let prevDate = new Date(self.selectedDates[0]);
                    prevDate.setDate(prevDate.getDate() - minSelect);
                    prevDate = formatDate(prevDate);

                    const daysBetweenPos = getDays(self.selectedDates[0], nextDate);
                    const daysBetweenNeg = getDays(prevDate, self.selectedDates[0]);
                    const removeDates = minSelect > 1 ? daysBetweenPos.concat(daysBetweenNeg) : [];

                    let enabledDates = allowedDates;
                    enabledDates = enabledDates.filter(function(item) {
                        return !removeDates.includes(item);
                    });
                    calendar.settings.range.enabled = enabledDates;
                    calendar.update();
                }
                if (self.selectedDates.length > 1) {
                    const start = self.selectedDates[0];
                    const end = self.selectedDates[self.selectedDates.length - 1];
                    const diffTime = Math.abs(new Date(end) - new Date(start));
                    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
                    const bookStayBtn = document.getElementById('book-a-stay');
                    if (diffDays > 0) {
                        bookStayBtn.classList.remove('d-none');
                        bookStayBtn.href = `https://hotels.cloudbeds.com/reservation/p0nzvZ#checkin=${start}&checkout=${end}`;
                    } else {
                        bookStayBtn.classList.add('d-none');
                    }
                }
            },
        },
        popups: {},
    });
    calendar.init();
}
